import { AutoMap } from "@automapper/classes";
import { Test } from "./test"

export class TestGroup {
    public constructor(init?: Partial<TestGroup>) {
        Object.assign(this, init);
    }

    @AutoMap()
    Code?: string
    @AutoMap()
    Name: string = ''
    @AutoMap()
    Position: number = 1;
    @AutoMap()
    IsDefault: boolean = false;
    @AutoMap()
    IsHidden: boolean = false;
    @AutoMap(() => Test)
    TestList: Test[] = []
    // UI ONLY
    IsVisible: boolean = true;
    //

}